<template>
  <v-app id="app">
    <v-main>
      <v-container
        fluid
      >
        <v-row align="center">
          <v-col cols="6" md="5" offset-md="1" style="text-align: left">
            <img style="max-width: 197px;" src="./assets/persona-logo.png">
          </v-col>
          <v-col cols="6" md="5" style="text-align: right">
            <a class="header-link" href="mailto:sales@personatalent.com">Contact</a>
            <a v-if="$route.name != 'login'" class="header-link header-link-so" href="/logout">Sign Out</a>
          </v-col>
        </v-row>
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
          >
    
            <p-title />

            <v-card class="main-card">
              <v-card-text>
                <router-view/>
              </v-card-text>
            </v-card>
            <div v-if="showAdmin" id="nav">
              Admin: 
              <router-link to="/login">Login</router-link> |
              <router-link to="/profile">Profile</router-link> |
              <router-link to="/terms">Terms</router-link> |
              <router-link to="/payment">Payment</router-link> |
              <router-link to="/">Account</router-link>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  name: 'App',
  components: {
    PTitle: () =>
      import(/* webpackChunkName: 'PTitle' */ '@/components/PTitle'),
  },
  data: () => ({
    //
  }),
  computed: {
    isAdmin() {
      const email = firebase && firebase.auth().currentUser ? firebase.auth().currentUser.email : ''
      return ['thatericsmith@gmail.com', 'jason@gopsychometric.com', 'nathan@gopsychometric.com'].includes(email)
    },
    showAdmin() {
      return this.isAdmin && this.$route.name != 'login'
    }
  }
}
</script>

<style>
html, body, #app {
  background: #FEF5FB;
  background: linear-gradient(270deg, #FEF5FB 0%, #F6F6FB 100%);
  color: #000046;
}
#app {
  font-family: Lato, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
p, h1, h2, h3, h4, h5, h6, li {
  color: #000046;
  line-height: 1.3;
}
h1, h2 {
  font-family: "Recoleta Alt", Georgia, serif;
}
.serif {
  font-family: "Recoleta Alt", Georgia, serif!important;
}
h1 {
  font-size: 36px;
  line-height: 49px;
  font-weight: bold;
  color: #22265E;
}
h2 {
  line-height: 49px;
  font-size: 36px;
  font-weight: normal;
  color: #485069;
}
.v-btn {
  text-transform: none!important;
  font-weight: bold!important;
  letter-spacing: 0!important;
}
#nav {
  padding: 30px;
}
#nav a {
  font-weight: bold;
  color: #4A4F63;
}
#nav a.router-link-exact-active {
  color: #000046;
}
.main-card {
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.0749563)!important;
  border-radius: 8px!important;
  max-width: 733px!important;
  margin: 0 auto;
}
a.header-link {
  text-decoration: none;
  font-weight: bold;
  color: #000046!important;
}
.header-link-so {
  padding-left: 24px;
}
.header-link:hover {
  text-decoration: underline;
}
</style>
